import { render } from "./App.vue?vue&type=template&id=b8ffa034"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b8ffa034&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/home/collin/workspace/elands/elandsweb/main-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__